import React from "react";
import PrimaryBTNWhite from "../../BTN/PrimaryBTNWhite";
import Timeline_1 from "../../../imgs/timeline/timeline_1.svg";
import Timeline_2 from "../../../imgs/timeline/timeline_2.svg";
import Timeline_3 from "../../../imgs/timeline/timeline_3.svg";
import "../../../styles/timeline.css";
import { withNamespaces } from 'react-i18next';

const FirstSection = ({t}) => {
  return (
    <section className="page-section" id="about">
      <div className="container">
        <h2 className="title_white">{t('moduleHomepage:S1.T')}</h2>
        <div className="orange_line"></div>
        <ul className="timeline">
          <li>
            <div className="timeline-image">
              <img
                className="rounded-circle img-fluid"
                src={Timeline_1}
                alt="Número 1"
              />
            </div>
            <div className="timeline-panel">
              <div className="timeline-heading">
                <h4 className="title_timeline">{t('moduleHomepage:S1.ST1.ST')}</h4>
              </div>
              <div className="timeline-body">
                <div>
                {t('moduleHomepage:S1.ST1.P')}
                  <PrimaryBTNWhite
                    texto={t('moduleBotoes:B1.B')}
                    alinhar="mt-3 text-sm-left text-md-right"
                    link="/prepararviagem"
                    title={t('moduleBotoes:B1.Title.B5')}
                  />
                </div>
              </div>
            </div>
          </li>
          <li className="timeline-inverted">
            <div className="timeline-image">
              <img
                className="rounded-circle img-fluid"
                src={Timeline_2}
                alt="Número 2"
              />
            </div>
            <div className="timeline-panel">
              <div className="timeline-heading">
                <h4 className="title_timeline">{t('moduleHomepage:S1.ST2.ST')}</h4>
              </div>
              <div className="timeline-body">
                <div>
                {t('moduleHomepage:S1.ST2.P')}
                  <PrimaryBTNWhite
                    texto={t('moduleBotoes:B1.B')}
                    alinhar="mt-3 text-start"
                    link="/chegadaaveiro"
                    title={t('moduleBotoes:B1.Title.B6')}
                  />
                </div>
              </div>
            </div>
          </li>
          <li>
            <div className="timeline-image">
              <img
                className="rounded-circle img-fluid"
                src={Timeline_3}
                alt="Número 3"
              />
            </div>
            <div className="timeline-panel">
              <div className="timeline-heading">
                <h4 className="title_timeline">{t('moduleHomepage:S1.ST3.ST')}</h4>
              </div>
              <div className="timeline-body">
                <div>
                {t('moduleHomepage:S1.ST3.P')}
                  <PrimaryBTNWhite
                    texto={t('moduleBotoes:B1.B')}
                    alinhar="mt-3 text-sm-left text-md-right"
                    link="/processointegracao"
                    title={t('moduleBotoes:B1.Title.B7')}
                  />
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default withNamespaces() (FirstSection);
